export default __webpack_public_path__ + "resources/icons/d342-fdf4.png";